import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const SenseIAA: FC = () => {
  const params = useParams<{symbol: string}>()

  useEffect(() => {
    const symbol = params.symbol

    window.location.href =
      `http://www.settrade.com/AnalystConsensus/C04_10_stock_saa_p1.jsp?txtSymbol=${symbol}`;
  }, [params.symbol]);

  return <div></div>;
};

export default SenseIAA;
